// Module
var code = "<input type=checkbox name=deletionCB style=margin-top:3px;margin-left:3px ng-disabled=\"!enableDeletionCheckbox || forbidDeletion\" ng-if=canEditOrdersPermission() ng-model=model.check[record.id]> ";
// Exports
module.exports = code;